import { useRef, useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";

import { useDispatch } from "react-redux";
import { setCredentials } from "./authSlice";
import { useLoginMutation } from "./authApiSlice";

import { ReactComponent as MarkNotesIcon } from "../../logo.svg";
import Stack from "@mui/material/Stack";
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";

import usePersist from "../../hooks/usePersist";

function Login() {
  //change it to email and use one state to handle all on change
  const userRef = useRef();
  const errRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userInfo, setUserInfo] = useState({
    email: "",
    password: "",
  });
  const [errMsg, setErrMsg] = useState("");
  const [persist, setPersist] = usePersist();
  const [login, { isLoading }] = useLoginMutation();
  useEffect(() => {
    userRef.current.focus(); //when it renders, focus directly in that username field
  }, []);

  useEffect(() => {
    setErrMsg("");
  }, [userInfo]);
  //}, [username, password]); //when email/password state changes, so we set it to empty

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      const { email, password } = userInfo;
      const { accessToken } = await login({ email, password }).unwrap();
      dispatch(setCredentials({ accessToken }));
      setUserInfo({
        email: "",
        password: "",
      });
      navigate("/", { replace: true });
    } catch (err) {
      if (!err.status) {
        setErrMsg("No Server Response");
      } else if (err.status === 400) {
        setErrMsg("Missing email or Password");
      } else if (err.status === 401) {
        setErrMsg("Unauthorized");
      } else {
        setErrMsg(err.data?.message);
      }
      errRef.current.focus();
    }
  }
  function handleUserInput(e) {
    const { value, name } = e.target;
    setUserInfo((preValue) => {
      return {
        ...preValue,
        [name]: value,
      };
    });
  }
  function handleToggle() {
    setPersist((preValue) => {
      return !preValue;
    });
  }
  const errClass = errMsg ? "errmsg" : "offscreen";
  //use icon here
  if (isLoading)
    return (
      <Stack alignItems="center" spacing={5}>
        <CircularProgress />
      </Stack>
    );

  return (
    <section>
      <main>
        <header className="login-header">
          <MarkNotesIcon />
          <h1>Login to MarkNotes</h1>
        </header>
        <form className="login" onSubmit={handleSubmit}>
          <label htmlFor="email">Email:</label>
          <input
            className="form-input"
            type="email"
            id="email"
            name="email"
            ref={userRef}
            value={userInfo.email}
            onChange={handleUserInput}
            autoComplete="off"
            required
          />
          <label htmlFor="password">Password:</label>
          <input
            className="form-input"
            type="password"
            id="password"
            name="password"
            onChange={handleUserInput}
            value={userInfo.password}
            required
          />
          <button className="form-submit-btn">Sign In</button>

          <label htmlFor="persist" className="form-persist">
            <Checkbox
              id="persist"
              className="form-checkbox"
              onChange={handleToggle}
              checked={persist}
            />
            Remember me
          </label>
          <p ref={errRef} className={errClass} aria-live="assertive">
            {errMsg}
          </p>
          <div className="align-text">
            <p className="align-left">
              <Link to="/forgot-password">Forgot Password</Link>
            </p>
            <p className="align-right">
              <Link to="/signup">Sign Up</Link>
            </p>
          </div>
        </form>
      </main>
    </section>
  );
}

export default Login;
